// extracted by mini-css-extract-plugin
module.exports = {"uk-open":"usps-component_uk-open__1w8Cw","grecaptcha-badge":"usps-component_grecaptcha-badge__obp7w","uspContainer":"usps-component_uspContainer__kgcln","icon":"usps-component_icon__JbD2D","text":"usps-component_text__TWzWG","usp":"usps-component_usp__iQqNV","outerWrapper":"usps-component_outerWrapper__gR1n4","innerWrapper":"usps-component_innerWrapper__8nt6z"};
    if(module.hot) {
      // 1793877031156
      var cssReload = require("!../../../../node_modules/.pnpm/css-hot-loader@1.4.4/node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  